export const FANTAPP_ROLE_OVERRIDES_CONFIGURATION = {
  'Aboukhlal': 'C',
  'Alisson Santos': 'A',
  'Assane Diao': 'A',
  'Bernasconi': 'D',
  'Cambiaghi': 'C',
  'Cancellieri': 'C',
  'De Ketelaere': 'A',
  'El Shaarawy': 'C',
  'Fini': 'C',
  'Ghedjemis': 'A',
  'Gonzalez N': 'C',
  'Gudmundsson': 'C',
  'Kuhn': 'A',
  'Laerke': 'C',
  'Lisman': 'A',
  'Maldini D': 'A',
  'Neres': 'A',
  'Noa Lang': 'A',
  'Pierotti': 'C',
  'Robinho J': 'A',
  'Robinson J': 'A',
  'Soule': 'A',
  'Sulemana K': 'A',
  'Zalewski': 'C',
};